<template>
  <div id="pers-tab2-3" name="hres32e-tab2-tab3">

    <div class="col-xs-12 col-md-6 pull-left">  
      <div class="col-xs-12  card-ui clearfix border-top-color-skin">
        <div class="sub-topic-box clearfix" @click="toggleSubTopic1">
          <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
          <div class="sub-topic">{{ labels['HRES32EC5']['20'] }}</div>
        </div>
        <div class="data-box clearfix" v-show="subTopic1">
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC5']['30'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="namfathr" name="namfathr" 
                     maxlength="45"
                     v-model="detail.namfathr" 
                     v-validate="'max:45'"
                     data-vv-name="namfathr"
                     data-vv-as="namfathr"
                     :has-error="errors.has('namfathr')" />
              <div class="text-error" v-show="errors.has('namfathr')">{{errors.first('namfathr')}}</div>
            </div>
          </div>      
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC5']['40'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-dropdown  v-model="detail.codfnatn" 
                                :options="dropdowns.codfnatn[nowLang]" 
                                style="margin-bottom:5px;"/>
            </div>
          </div>      
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC5']['50'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-dropdown  v-model="detail.codfrelg" 
                                :options="dropdowns.codfrelg[nowLang]" 
                                style="margin-bottom:5px;"/>
            </div>
          </div>      
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC5']['60'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-dropdown  v-model="detail.codfoccu" 
                                :options="dropdowns.codfoccu[nowLang]" 
                                style="margin-bottom:5px;"/>
            </div>
          </div>    
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC5']['70'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="numofidf" name="numofidf" 
                     v-model="detail.numofidf" 
                     maxlength="13"
                     v-validate="'max:13'"
                     data-vv-name="numofidf"
                     data-vv-as="numofidf"
                     :has-error="errors.has('numofidf')" />
              <div class="text-error" v-show="errors.has('numofidf')">{{errors.first('numofidf')}}</div>
            </div>
          </div>        
        </div>
      </div>
    </div>

    <div class="col-xs-12 col-md-6 pull-right">  
      <div class="col-xs-12  card-ui clearfix border-top-color-skin">
        <div class="sub-topic-box clearfix" @click="toggleSubTopic2">
          <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
          <div class="sub-topic">{{ labels['HRES32EC5']['80'] }}</div>
        </div>
        <div class="data-box clearfix" v-show="subTopic2">
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC5']['90'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="nammothr" name="nammothr" 
                     v-model="detail.nammothr" 
                     maxlength="45"
                     v-validate="'max:45'"
                     data-vv-name="nammothr"
                     data-vv-as="nammothr"
                     :has-error="errors.has('nammothr')" />
              <div class="text-error" v-show="errors.has('nammothr')">{{errors.first('nammothr')}}</div>
            </div>
          </div>      
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC5']['100'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-dropdown  v-model="detail.codmnatn" 
                                :options="dropdowns.codfnatn[nowLang]" 
                                style="margin-bottom:5px;"/>
            </div>
          </div>      
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC5']['110'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-dropdown  v-model="detail.codmrelg" 
                                :options="dropdowns.codfrelg[nowLang]" 
                                style="margin-bottom:5px;"/>
            </div>
          </div>      
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC5']['120'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-dropdown  v-model="detail.codmoccu" 
                                :options="dropdowns.codfoccu[nowLang]" 
                                style="margin-bottom:5px;"/>
            </div>
          </div>    
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC5']['130'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="numofidm" name="numofidm" 
                     v-model="detail.numofidm" 
                     maxlength="13"
                     v-validate="'max:13'"
                     data-vv-name="numofidm"
                     data-vv-as="numofidm"
                     :has-error="errors.has('numofidm')" />
              <div class="text-error" v-show="errors.has('numofidm')">{{errors.first('numofidm')}}</div>
            </div>
          </div>  
           
        </div>
      </div>
    </div>

    <div class="col-xs-12 col-md-6 pull-left">  
      <div class="col-xs-12  card-ui clearfix border-top-color-skin">
        <div class="sub-topic-box clearfix" @click="toggleSubTopic3">
          <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
          <div class="sub-topic">{{ labels['HRES32EC5']['140'] }}</div>
        </div>
        <div class="data-box clearfix" v-show="subTopic3">
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC5']['150'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="namcont" name="namcont" 
                     v-model="detail.namcont" 
                     maxlength="45"
                     v-validate="'max:45'"
                     data-vv-name="namcont"
                     data-vv-as="namcont"
                     :has-error="errors.has('namcont')" />
              <div class="text-error" v-show="errors.has('namcont')">{{errors.first('namcont')}}</div>
            </div>
          </div>  
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC5']['160'] }}</div>
            <div class="col-xs-7 data-input">
                <textarea class="form-control textarea-text" id="adrcont1" name="adrcont1" 
                          v-model="detail.adrcont1" 
                          maxlength="100"
                          v-validate="'max:100'"
                          data-vv-name="adrcont1"
                          data-vv-as="adrcont1"
                          :has-error="errors.has('adrcont1')"></textarea>
                <div class="text-error" v-show="errors.has('adrcont1')">{{errors.first('adrcont1')}}</div>
                <div class="remark-limit-character">{{ dispLimitLabel(100) }}</div> 
            </div>
          </div>  
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC5']['170'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="codpost" name="codpost" 
                     v-model="detail.codpost" 
                     maxlength="5"
                     v-validate="'numeric|max:5'"
                     data-vv-name="codpost"
                     data-vv-as="codpost"
                     :has-error="errors.has('codpost')" />
              <div class="text-error" v-show="errors.has('codpost')">{{errors.first('codpost')}}</div>
            </div>
          </div> 
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC5']['200'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="email" name="email" 
                     v-model="detail.email" 
                     maxlength="50"
                     v-validate="'max:50'"
                     data-vv-name="email"
                     data-vv-as="email"
                     :has-error="errors.has('email')" />
              <div class="text-error" v-show="errors.has('email')">{{errors.first('email')}}</div>
            </div>
          </div> 
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC5']['180'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="numtele" name="numtele" 
                     v-model="detail.numtele" 
                     maxlength="20"
                     v-validate="'max:20'"
                     data-vv-name="numtele"
                     data-vv-as="numtele"
                     :has-error="errors.has('numtele')" />
              <div class="text-error" v-show="errors.has('numtele')">{{errors.first('numtele')}}</div>
            </div>
          </div> 
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC5']['190'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="numfax" name="numfax" 
                     v-model="detail.numfax" 
                     maxlength="20"
                     v-validate="'max:20'"
                     data-vv-name="numfax"
                     data-vv-as="numfax"
                     :has-error="errors.has('numfax')" />
              <div class="text-error" v-show="errors.has('numfax')">{{errors.first('numfax')}}</div>
            </div>
          </div> 
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC5']['210'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="desrelat" name="desrelat" 
                     v-model="detail.desrelat" 
                     maxlength="15"
                     v-validate="'max:15'"
                     data-vv-name="desrelat"
                     data-vv-as="desrelat"
                     :has-error="errors.has('desrelat')" />
              <div class="text-error" v-show="errors.has('desrelat')">{{errors.first('desrelat')}}</div>
            </div>
          </div>                  
        </div>
      </div>
    </div>
    
    <div class="col-md-12 box-footer">
      <button type="button" class="btn bg-dark-gray pull-left" @click="togglePage(0)" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
      <button type="button" class="btn bg-color-skin" @click="callSave()" v-if="validateStaappr"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
    </div>
  </div>
</template>

<script>
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hres32e-tab2-tab3',
  data () {
    return {
      subTopic1: true,
      subTopic2: true,
      subTopic3: true
    }
  },
  watch: {
    'detail.namfathr' () {
      this.$validator.validate('namfathr', this.detail.namfathr).catch(e => {})
    },
    'detail.numofidf' () {
      this.$validator.validate('numofidf', this.detail.numofidf).catch(e => {})
    },
    'detail.nammothr' () {
      this.$validator.validate('nammothr', this.detail.nammothr).catch(e => {})
    },
    'detail.numofidm' () {
      this.$validator.validate('numofidm', this.detail.numofidm).catch(e => {})
    },
    'detail.namcont' () {
      this.$validator.validate('namcont', this.detail.namcont).catch(e => {})
    },
    'detail.adrcont1' () {
      this.$validator.validate('adrcont1', this.detail.adrcont1).catch(e => {})
    },
    'detail.codpost' () {
      this.$validator.validate('codpost', this.detail.codpost).catch(e => {})
    },
    'detail.email' () {
      this.$validator.validate('email', this.detail.email).catch(e => {})
    },
    'detail.numtele' () {
      this.$validator.validate('numtele', this.detail.numtele).catch(e => {})
    },
    'detail.numfax' () {
      this.$validator.validate('numfax', this.detail.numfax).catch(e => {})
    },
    'detail.desrelat' () {
      this.$validator.validate('desrelat', this.detail.desrelat).catch(e => {})
    },
    detail () {
      this.$nextTick(() => {
        this.errors.clear()
      })
    }
  },
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    toggleSubTopic1 () {
      this.subTopic1 = !this.subTopic1
    },
    toggleSubTopic2 () {
      this.subTopic2 = !this.subTopic2
    },
    toggleSubTopic3 () {
      this.subTopic3 = !this.subTopic3
    },
    saveParams () {
      return {
        p_dtereq: this.indexSelected.dtereq,
        p_numseq: this.indexSelected.numseq,
        n_namfathr: this.detail.namfathr,
        n_codfnatn: this.detail.codfnatn,
        n_codfrelg: this.detail.codfrelg,
        n_codfoccu: this.detail.codfoccu,
        n_numofidf: this.detail.numofidf,
        n_nammothr: this.detail.nammothr,
        n_codmnatn: this.detail.codmnatn,
        n_codmrelg: this.detail.codmrelg,
        n_codmoccu: this.detail.codmoccu,
        n_numofidm: this.detail.numofidm,
        n_namcont: this.detail.namcont,
        n_adrcont1: this.detail.adrcont1,
        n_codpost: this.detail.codpost,
        n_numtele: this.detail.numtele,
        n_email: this.detail.email,
        n_numfax: this.detail.numfax,
        n_desrelat: this.detail.desrelat
      }
    },
    callSave () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.postDetail2Tab3Save({ saveParams: this.saveParams(), searchIndex: this.searchIndex, togglePage: this.togglePage })
        }
      })
    }
  },
  props: [ 'nowLang', 'labels', 'detail', 'indexSelected', 'pcDisp', 'togglePage', 'toggleSubPage', 'triggerSubButton', 'labelsButton', 'dropdowns', 'postDetail2Tab3Save', 'searchIndex', 'validateStaappr' ]
}

</script>


// WEBPACK FOOTER //
// tab2_3.vue?b4bdce3c